

































































import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import ViewTiers from '@/views/Reports/Reward Plans/ViewTiers.vue';
import RevshareViewTiers from '@/views/Reports/Reward Plans/RevshareViewTiers.vue';
import ExpandedViewTiers from '@/views/Reports/Reward Plans/ExpandedViewTiers.vue';
import {
  AuthorizationStore,
  CommonsStore,
  CpacommissionStore,
  Payload,
} from '@samclick-store-factory';
import * as dateUtils from '@/utils/date-utils';
import { sortString } from '@/utils/common-utils';
import { _reverse, _isEmpty, _forEach } from '@samclick-lodash';

class RewardPlansState {

}

    @Component({
      /**
         * Imported components
         * */
      components: { ViewTiers, RevshareViewTiers, ExpandedViewTiers },
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          loading: (state: any) => state.cpa.cpacommissionStore.loading,
          rewardPlans: (state: any) => state.cpa.cpacommissionStore.rewardPlans,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class RewardPlans extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        componentState = this.defaultState()

        defaultState() {
          return {
            casino: '',
            affiliateID: '',
            cpaSetName: '',
            showDialog: false,
            showDialogRevshare: false,
            showDialogExpanded: false,
            editCpaDtls: {},
          };
        }

        /**
         * Watchers
         * */
        @Watch('componentState.var')
        sampleWatcher(newVal: string, oldVal: string) {

        }

        /**
         * Methods
         * */

        submitSearch() {
          CpacommissionStore.getRewardPlans(new Payload({ affiliate_id: this.getAffiliateID }));
        }

        getCasinoDescription(id: number) {
          return CommonsStore.casinoAllDescription(id) ? CommonsStore.casinoAllDescription(id).code : '';
        }

        toggleViewTiers(show: boolean, editCpaDtls: Object, resubmit: boolean = false) {
          this.componentState.showDialog = show;
          this.componentState.editCpaDtls = editCpaDtls;
          if (resubmit) {
            this.submitSearch();
          }
        }

        toggleRevshareViewTiers(show: boolean, editCpaDtls: Object, resubmit: boolean = false) {
          this.componentState.showDialogRevshare = show;
          this.componentState.editCpaDtls = editCpaDtls;
          if (resubmit) {
            this.submitSearch();
          }
        }

        toggleExpandedViewTiers(show: boolean, editCpaDtls: Object, resubmit: boolean = false) {
          this.componentState.showDialogExpanded = show;
          this.componentState.editCpaDtls = editCpaDtls;
          if (resubmit) {
            this.submitSearch();
          }
        }

        sortByCasinoCode(a: any, b: any) {
          return sortString(this.getCasinoDescription(a.service_id), this.getCasinoDescription(b.service_id));
        }

        get rewardPlansList() {
          let newRewardPlans = this.rewardPlans.filter((rewardPlan: LooseObject) => {
            if (!CommonsStore.casinoCode(rewardPlan.service_id) && rewardPlan.type != 'tierSet') {
              return false;
            }
            
            return true;
          });
          
          return newRewardPlans;
        }

        /**
         * Computed
         * */
        get computedVal() {
          return {};
        }

        get getAffiliateID() {
          let affiliate_id = AuthorizationStore.currentLoggedUserInState.id;
          if (affiliate_id === undefined || affiliate_id === null) {
            const local_json_string = localStorage.getItem('ma-auth.currentUser') as string;
            affiliate_id = JSON.parse(local_json_string).id;
          }

          return affiliate_id;
        }

        /**
         * Lifecycle hooks
         * */
        created() {
          this.submitSearch();
          CommonsStore.fetchAllCasino();
        }

        mounted() {
        }

        beforeUpdate() {
        }

        beforeCreate() {
          this._ = { reverse: _reverse };
          this.dateUtils = dateUtils;
        }
}
